import Http from '../../http/client';
import UniqueId from '../getters/uniqueId';
import Bowser from 'bowser';
import Config from '../../config';
import Store from '../../store';

const browser = Bowser.getParser(window.navigator.userAgent);

export default async ({validationId, code}) => {
  const response = await Http.post('auth/validate', {
    validationId,
    code,
    device: {
      uniqueId: UniqueId(),
      brand: browser.getOSName(),
      model: browser.getBrowserName(),
      osVersion: browser.getBrowserVersion(),
      platform: "BROWSER",
      isEmulator: false,
      isTablet: false,
      isRooted: false
    },
    userMeta: {
      carrier: browser.getPlatform().vendor || "desktop",
      appVersion: Config.version
    }
  });

  Store.commit('SignIn', response.data.accessToken);
}
